<script lang="ts">
  import Lightbulb from '@lucide/svelte/icons/lightbulb';

  import { getServices } from '../../app/context';
  import { strings } from '../../strings';
  import Button from '../../ui/Button.svelte';

  const { settings } = getServices();
</script>

{#if !settings.value.hintDismissed}
  <aside
    aria-label={strings.hintTitle}
    class="mb-3 flex flex-wrap items-center gap-3 rounded-card border border-line bg-surface p-3 text-sm print:hidden"
  >
    <Lightbulb size={18} aria-hidden="true" class="shrink-0 text-accent" />
    <p class="min-w-0 flex-1">{strings.hint}</p>
    <Button
      size="sm"
      onclick={() => {
        settings.update({ hintDismissed: true });
      }}
    >
      {strings.dismissHint}
    </Button>
  </aside>
{/if}
